/**
 * CAD Link Store
 *
 * Keeps the in-memory File handle of every linked/imported CAD drawing so a
 * Reload can re-parse the exact same file without opening the picker again.
 * File handles are valid for the browser session; after a reload of the app
 * itself the handle is gone and Reload falls back to the file dialog.
 */

export interface CadSource {
    /** Picked File object (session-only). */
    file: File | null;
    /** Last-known file path/name for display + extension routing. */
    fileName: string;
    /** When the source was last read into geometry. */
    lastLoaded: number;
}

class CadLinkStoreImpl {
    private sources = new Map<string, CadSource>();

    setSource(key: string, file: File | null, fileName: string): void {
        this.sources.set(key, { file, fileName, lastLoaded: Date.now() });
    }

    getSource(key: string): CadSource | undefined {
        return this.sources.get(key);
    }

    removeSource(key: string): void {
        this.sources.delete(key);
    }

    /** Touch timestamp after a successful reload. */
    markLoaded(key: string): void {
        const s = this.sources.get(key);
        if (s) s.lastLoaded = Date.now();
    }
}

export const CadLinkStore = new CadLinkStoreImpl();
